import * as _ from 'underscore';

angular.module('app').service('PerformanceTracking', ['$q', '$http', '$interval', '$timeout', '$location', ($q, $http, $interval, $timeout, $location) => {
  var $scope = this || {};

  return $scope;
}]);